import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { DataService } from 'services/data.service';
import { StatusNames } from 'domain-models/StatusNames';
import { environment } from '../../environments/environment';

@Injectable()
export class StatusNamesService extends DataService<StatusNames> {
	constructor(http: Http) {
		super(environment.host + 'StatusNames', http);
	}
}



// WEBPACK FOOTER //
// /Users/baselkilani/work/ODOT/projects/dmscontrol/DmsControl/src/services/statusNames/status-names.service.ts